module.exports = __webpack_public_path__ + "static/media/pendingNotify.d4bc8fd5.svg";